export const AI_PROMPT_QUERY_KEY = 'prompt' as const;
export const AI_TOPIC_ID_QUERY_KEY = 'topic_id' as const;
export const AI_AUTO_TRIGGER_STORAGE_KEY = 'zep-quiz:ai-auto-trigger' as const;

export type { AiAutoTriggerData } from '@/shared/features/ai-quiz-generation/types';
